
var ReactDOM = require('react-dom');
var Heatmap = require('heatmap.js');
var React = require('react');

class ReactHeatmap extends React.Component {

	constructor(props) {
		super(props);
		this.setData = this.setData.bind(this);

		console.log(props)
	}

	componentDidMount() {
		this.heatmap = Heatmap.create({
		  container: ReactDOM.findDOMNode(this),
			"width": 290,
			"height": 198.5,
			"radius": 50,
			"gradient": { 0.45: "yellow", 0.65: "orange", 0.85: "red" }
		});

		this.setData(this.props.max, this.props.data);
	}

	componentWillReceiveProps(newProps) {
		this.setData(newProps.max, newProps.data);
	}

	setData(max, data) {
		this.heatmap.setData({
		  max: max,
		  data: this.computeData(data)
		});
	}

	computeData(data) {
		if(this.props.unit === 'percent') {
			let container = {};
			container.width = ReactDOM.findDOMNode(this).offsetWidth;
			container.height = ReactDOM.findDOMNode(this).offsetHeight;
			return data.map(function(values, index) {
				return {
					x : values.x/100 * container.width,
					y : values.y/100 * container.height
				}
			});
		} else {
			return data;
		}
	}

	render () {
		return( 
			<div style={{width: '100%', height: '100%'}}></div>
		);
	}
}

module.exports =  ReactHeatmap;



// WEBPACK FOOTER //
// ./src/common/ReactHeatmap/ReactHeatmap.js